import { useMutation, useQueryClient } from "@tanstack/react-query"
import { profile } from  '@shared/api/services'
import { toast } from "react-toastify"

export const useUpdatePhotos = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profile.updatePhotos(data),
		onError: err => console.log(err),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
			toast.success('Фотографии обновлены')
    },
  })

	return mutation
}